import React, { memo } from 'react';
import CSVPreviewRenderer from './CSVPreviewRenderer';
import { CSVPreviewProps } from '../types';

/**
 * Wrapper component to isolate CSV preview rendering and prevent hook issues
 */
const CSVPreviewWrapper: React.FC<CSVPreviewProps> = memo(
  ({ apiEndpoint, fileUrl, filename, mimeType, fileSize, maxPreviewRows }) => {
    // Only render if we have required props (either apiEndpoint or fileUrl, and filename)
    if ((!apiEndpoint && !fileUrl) || !filename) {
      return null;
    }

    return (
      <CSVPreviewRenderer
        apiEndpoint={apiEndpoint}
        fileUrl={fileUrl}
        filename={filename}
        mimeType={mimeType}
        fileSize={fileSize}
        maxPreviewRows={maxPreviewRows}
      />
    );
  }
);

CSVPreviewWrapper.displayName = 'CSVPreviewWrapper';

export default CSVPreviewWrapper;
